// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"489": "MachineTranslationButtonContainer","664": "RelatedLinks","83": "CreateCollectionModal","882": "NotableClientsAbout","883": "SaveToListPopover",}[chunkId] + "." + {"489": "0315d7035d0211e8","664": "8ae5b5dc22f070e7","83": "2209e9ae1d6ccea3","882": "8384e26683b2e784","883": "9ea20e6ee6bd777e",}[chunkId] + ".css"
}